import React from "react";
import COLORS from "../../constants/colors";
import {
  mainCardStyle,
  pageStyle,
  primaryBtnStyle,
} from "../../styles/commonStyles";

export default function SpellingPromptPage({
  title = "进入单词拼写环节",
  desc = "你可以选择继续进行拼写练习，也可以先跳过，稍后再练习。",
  onStart,
  onSkip,
}) {
  return (
    <div style={pageStyle()}>
      <div style={mainCardStyle()}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "2.4rem" }}>✍️</div>

          <div
            style={{
              marginTop: "0.7rem",
              fontSize: "1.6rem",
              fontWeight: 800,
              color: COLORS.text,
            }}
          >
            {title}
          </div>

          <div
            style={{
              marginTop: "0.8rem",
              color: COLORS.subtext,
              lineHeight: 1.8,
            }}
          >
            {desc}
          </div>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              marginTop: "1.6rem",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={onStart}
              style={{
                ...primaryBtnStyle(),
                flex: 1,
                minWidth: "180px",
              }}
            >
              开始拼写
            </button>

            <button
              onClick={onSkip}
              style={{
                flex: 1,
                minWidth: "180px",
                border: `1px solid ${COLORS.line}`,
                borderRadius: "14px",
                padding: "0.9rem 1.2rem",
                background: "#fff",
                color: COLORS.text,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              暂时跳过
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}